/* ============================================================
   TRIPPYKONG® — THE BLACK REALM
   Master JavaScript v2.0
   Mobile-optimized
   ============================================================ */

(function () {

'use strict';


/* ============================================================
   FADE IN ANIMATION
============================================================ */

function initFadeIn(){

const elements = document.querySelectorAll('.fade-in');

if(!elements.length) return;

const observer = new IntersectionObserver(entries => {

entries.forEach(entry => {

if(entry.isIntersecting){

entry.target.classList.add('is-visible');
observer.unobserve(entry.target);

}

});

},{threshold:0.1});

elements.forEach(el => observer.observe(el));

}


/* ============================================================
   STICKY HEADER
============================================================ */

function initStickyHeader(){

const header = document.getElementById('site-header');

if(!header) return;

window.addEventListener('scroll',function(){

if(window.scrollY > 60){

header.classList.add('scrolled');

}else{

header.classList.remove('scrolled');

}

},{passive:true});

}


/* ============================================================
   MOBILE NAV
============================================================ */

function initMobileNav(){
const hamburger=document.getElementById('hamburger');
const mobileNav=document.getElementById('mobile-nav');
if(!hamburger||!mobileNav)return;
const desktop=matchMedia('(min-width: 1024px)');
function setOpen(open,returnFocus=false){
hamburger.classList.toggle('is-open',open);
mobileNav.classList.toggle('is-open',open);
hamburger.setAttribute('aria-expanded',String(open));
hamburger.setAttribute('aria-controls','mobile-nav');
if(returnFocus)hamburger.focus();
}
hamburger.addEventListener('click',()=>setOpen(!hamburger.classList.contains('is-open')));
mobileNav.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>setOpen(false)));
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&hamburger.classList.contains('is-open'))setOpen(false,true)});
document.addEventListener('click',e=>{if(hamburger.classList.contains('is-open')&&!e.target.closest('#site-header'))setOpen(false)});
desktop.addEventListener('change',e=>{if(e.matches&&hamburger.classList.contains('is-open'))setOpen(false)});
hamburger.setAttribute('aria-controls','mobile-nav');
}


/* ============================================================
   PRODUCT GALLERY
============================================================ */

function initProductGallery(){

const gallery = document.getElementById('product-gallery');

if(!gallery) return;

const slides = Array.from(gallery.querySelectorAll('.product-gallery__slide'));
const thumbs = Array.from(gallery.querySelectorAll('.product-gallery__thumb'));

let index = 0;

function showSlide(i){

slides.forEach((slide,n)=>{

slide.classList.toggle('is-active',n===i);

});

thumbs.forEach((thumb,n)=>{

thumb.classList.toggle('is-active',n===i);

});

index = i;

}

/* click thumbnails */

thumbs.forEach((thumb,i)=>{

thumb.addEventListener('click',()=>{

showSlide(i);

});

});


/* MOBILE SWIPE */

let startX = 0;

gallery.addEventListener('touchstart',e=>{

startX = e.touches[0].clientX;

});

gallery.addEventListener('touchend',e=>{

let endX = e.changedTouches[0].clientX;

if(startX - endX > 50){

showSlide(Math.min(index+1,slides.length-1));

}

if(endX - startX > 50){

showSlide(Math.max(index-1,0));

}

});

}


/* ============================================================
   VARIANT SELECTOR UI
============================================================ */

function initVariantSelector(){

const form = document.getElementById('product-form');

if(!form) return;

const inputs = form.querySelectorAll('.option-swatch__input');

inputs.forEach(input=>{

input.addEventListener('change',function(){

const group = input.closest('.product-option__values');

group.querySelectorAll('.option-swatch')
.forEach(el=>el.classList.remove('is-selected'));

input.closest('.option-swatch')
.classList.add('is-selected');

});

});

}


/* ============================================================
   VARIANT PRICE UPDATE
============================================================ */

function initVariantPrice(){

const productJSON = document.getElementById('ProductJson');

if(!productJSON) return;

const variants = JSON.parse(productJSON.textContent);

const priceEl = document.getElementById('product-price');
const form = document.getElementById('product-form');
const variantInput = document.getElementById('variant-id');

form.addEventListener('change',function(){

let selectedOptions = [];

form.querySelectorAll('.option-swatch__input:checked')
.forEach(input=>{

selectedOptions.push(input.value);

});

const match = variants.find(v=>{

return JSON.stringify(v.options) === JSON.stringify(selectedOptions);

});

if(match){

variantInput.value = match.id;

if(priceEl){

priceEl.innerText = Shopify.formatMoney(match.price);

}

}

});

}


/* ============================================================
   AJAX ADD TO CART
============================================================ */

function initAddToCart(){

const form = document.getElementById('product-form');

if(!form) return;

form.addEventListener('submit',function(e){

e.preventDefault();

const btn = document.getElementById('add-to-cart-btn');

btn.disabled = true;
btn.innerText = "Adding...";

const formData = new FormData(form);

fetch('/cart/add.js',{
method:'POST',
body:formData
})

.then(r=>r.json())

.then(()=>{

btn.innerText = "✓ Added";

updateCartCount();

setTimeout(()=>{

btn.disabled=false;
btn.innerText="Add to Cart";

},2000);

})

.catch(()=>{

btn.disabled=false;
btn.innerText="Error";

});

});

}


/* ============================================================
   CART COUNT
============================================================ */

function updateCartCount(){

fetch('/cart.js')

.then(r=>r.json())

.then(cart=>{

const el = document.getElementById('cart-count');

if(el){

el.textContent = cart.item_count;

}

});

}


/* ============================================================
   CART PAGE CONTROLS
============================================================ */

function bindCartPageControls(){

const cartForm = document.querySelector('.cart-form');

if(!cartForm) return;

/* REMOVE ITEM */

cartForm.addEventListener('click',function(e){

const removeBtn = e.target.closest('.cart-remove');

if(!removeBtn) return;

e.preventDefault();

const variantId = removeBtn.dataset.variantId;

if(!variantId) return;

fetch('/cart/update.js',{
method:'POST',
headers:{'Content-Type':'application/json'},
body:JSON.stringify({
updates:{[variantId]:0}
})
})

.then(()=>location.reload());

});


/* UPDATE QTY */

cartForm.addEventListener('change',function(e){

if(!e.target.classList.contains('cart-qty-input')) return;

const variantId = e.target.dataset.variantId;

const qty = parseInt(e.target.value);

fetch('/cart/update.js',{
method:'POST',
headers:{'Content-Type':'application/json'},
body:JSON.stringify({
updates:{[variantId]:qty}
})
})

.then(()=>location.reload());

});

}


/* ============================================================
   CURSOR GLOW
============================================================ */

function initCursorGlow(){

if(window.matchMedia('(pointer: coarse)').matches) return;

const glow = document.createElement('div');

glow.id = 'cursor-glow';

glow.style.cssText = `
position:fixed;
width:300px;
height:300px;
border-radius:50%;
pointer-events:none;
z-index:9999;
transform:translate(-50%,-50%);
background:radial-gradient(circle,rgba(206,255,0,0.04)0%,transparent 70%);
`;

document.body.appendChild(glow);

document.addEventListener('mousemove',e=>{

glow.style.left = e.clientX + 'px';
glow.style.top = e.clientY + 'px';

});

}


/* ============================================================
   INIT
============================================================ */

function init(){

initFadeIn();

initStickyHeader();

initMobileNav();

initProductGallery();

initVariantSelector();

initVariantPrice();

initAddToCart();

bindCartPageControls();

initCursorGlow();

updateCartCount();

}

document.addEventListener('DOMContentLoaded',init);

})();
